(function(){
  if (!document.getElementById('srStage')) return;
  if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;

  // Lazy import three.js
  const importMap = document.createElement('script');
  importMap.type = 'importmap';
  importMap.textContent = JSON.stringify({
    imports: {
      'three': 'https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js',
      'three/addons/': 'https://cdn.jsdelivr.net/npm/three@0.160.0/examples/jsm/'
    }
  });
  // Insert importmap only if not already there
  if (!document.querySelector('script[type="importmap"]')) {
    document.head.appendChild(importMap);
  }

  const code = `
import * as THREE from 'three';
import { PointerLockControls } from 'three/addons/controls/PointerLockControls.js';

const PRODUCTS = window.__onaShowroomProducts || [];
const stage = document.getElementById('srStage');
const overlay = document.getElementById('srOverlay');
const hud = document.getElementById('srHud');
const crosshair = document.getElementById('srCrosshair');
const modal = document.getElementById('srModal');

const canvas = document.createElement('canvas');
stage.appendChild(canvas);

const scene = new THREE.Scene();
scene.background = new THREE.Color(0xF0E0D0);
scene.fog = new THREE.Fog(0xF0E0D0, 18, 60);

const camera = new THREE.PerspectiveCamera(70, stage.clientWidth/stage.clientHeight, 0.1, 200);
camera.position.set(0, 1.7, 8);

const renderer = new THREE.WebGLRenderer({canvas, antialias:true});
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
renderer.setSize(stage.clientWidth, stage.clientHeight);
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;

scene.add(new THREE.AmbientLight(0xFFE8D8, 0.7));
const sun = new THREE.DirectionalLight(0xFFD0B0, 0.9);
sun.position.set(8, 14, 5); sun.castShadow = true;
sun.shadow.mapSize.set(1024, 1024);
sun.shadow.camera.left = -25; sun.shadow.camera.right = 25;
sun.shadow.camera.top = 25; sun.shadow.camera.bottom = -25;
scene.add(sun);

const floor = new THREE.Mesh(
  new THREE.PlaneGeometry(60, 60),
  new THREE.MeshStandardMaterial({color:0xE8D5C0, roughness:0.95})
);
floor.rotation.x = -Math.PI/2; floor.receiveShadow = true; scene.add(floor);

const wallMat = new THREE.MeshStandardMaterial({color:0xD2B4B4, roughness:0.9});
const wallGeo = new THREE.PlaneGeometry(60, 12);
[[0,6,-25,0],[25,6,0,-Math.PI/2],[-25,6,0,Math.PI/2],[0,6,25,Math.PI]].forEach(([x,y,z,r])=>{
  const w = new THREE.Mesh(wallGeo, wallMat);
  w.position.set(x,y,z); w.rotation.y = r; w.receiveShadow = true;
  scene.add(w);
});
const ceil = new THREE.Mesh(new THREE.PlaneGeometry(60,60), new THREE.MeshStandardMaterial({color:0xFBF6EF, roughness:1}));
ceil.position.y = 12; ceil.rotation.x = Math.PI/2; scene.add(ceil);

const loader = new THREE.TextureLoader();
const cards = [];
PRODUCTS.forEach((p, i)=>{
  const angle = (i / PRODUCTS.length) * Math.PI * 2;
  const r = 8;
  const px = Math.sin(angle) * r, pz = Math.cos(angle) * r;
  const pod = new THREE.Mesh(
    new THREE.CylinderGeometry(1, 1.1, 1.2, 32),
    new THREE.MeshStandardMaterial({color:0x5C4470, roughness:0.5, metalness:0.1})
  );
  pod.position.set(px, 0.6, pz); pod.castShadow = true; pod.receiveShadow = true;
  scene.add(pod);
  const tex = loader.load(p.img);
  tex.colorSpace = THREE.SRGBColorSpace;
  const card = new THREE.Mesh(
    new THREE.PlaneGeometry(1.6, 2),
    new THREE.MeshStandardMaterial({map:tex, roughness:0.4, side:THREE.DoubleSide})
  );
  card.position.set(px, 2.4, pz); card.lookAt(0, 2.4, 0); card.castShadow = true;
  card.userData.product = p;
  scene.add(card); cards.push(card);
  const sp = new THREE.SpotLight(0xFFE0C0, 1.4, 8, Math.PI/5, 0.5, 2);
  sp.position.set(px, 6, pz); sp.target = pod; scene.add(sp);
});

const ring = new THREE.Mesh(
  new THREE.TorusGeometry(1.2, 0.05, 16, 64),
  new THREE.MeshStandardMaterial({color:0xB8A4C9, roughness:0.4, metalness:0.6})
);
ring.position.set(0, 4, 0); ring.rotation.x = Math.PI/2; scene.add(ring);

const controls = new PointerLockControls(camera, document.body);
const move = {f:false, b:false, l:false, r:false};
const v = new THREE.Vector3();
const dir = new THREE.Vector3();

document.getElementById('srEnter').addEventListener('click', ()=>{ controls.lock(); });
controls.addEventListener('lock', ()=>{
  overlay.classList.add('hidden');
  hud.classList.add('show');
  crosshair.classList.add('show');
});
controls.addEventListener('unlock', ()=>{
  overlay.classList.remove('hidden');
  hud.classList.remove('show');
  crosshair.classList.remove('show');
});

document.addEventListener('keydown', e=>{
  if (!controls.isLocked) return;
  if (e.code==='KeyW' || e.code==='ArrowUp') move.f = true;
  if (e.code==='KeyS' || e.code==='ArrowDown') move.b = true;
  if (e.code==='KeyA' || e.code==='ArrowLeft') move.l = true;
  if (e.code==='KeyD' || e.code==='ArrowRight') move.r = true;
});
document.addEventListener('keyup', e=>{
  if (e.code==='KeyW' || e.code==='ArrowUp') move.f = false;
  if (e.code==='KeyS' || e.code==='ArrowDown') move.b = false;
  if (e.code==='KeyA' || e.code==='ArrowLeft') move.l = false;
  if (e.code==='KeyD' || e.code==='ArrowRight') move.r = false;
});

document.addEventListener('click', ()=>{
  if (!controls.isLocked) return;
  const ray = new THREE.Raycaster();
  ray.setFromCamera(new THREE.Vector2(0,0), camera);
  const hits = ray.intersectObjects(cards);
  if (hits.length && hits[0].distance < 5){
    const p = hits[0].object.userData.product;
    document.getElementById('srMNum').textContent = '— Pièce No. ' + p.num;
    document.getElementById('srMName').textContent = p.name;
    document.getElementById('srMPrice').textContent = p.price;
    document.getElementById('srMImg').src = p.img;
    document.getElementById('srMLink').href = p.url;
    modal.classList.add('show');
    controls.unlock();
  }
});
document.getElementById('srMClose').addEventListener('click', ()=>{
  modal.classList.remove('show');
});

let last = performance.now();
function animate(){
  requestAnimationFrame(animate);
  const t = performance.now();
  const dt = Math.min((t-last)/1000, 0.05);
  last = t;
  ring.rotation.z += dt * 0.2;
  if (controls.isLocked){
    v.x -= v.x * 10 * dt;
    v.z -= v.z * 10 * dt;
    dir.set(0,0,0);
    if (move.f) dir.z -= 1;
    if (move.b) dir.z += 1;
    if (move.l) dir.x -= 1;
    if (move.r) dir.x += 1;
    dir.normalize();
    const speed = 22;
    if (move.f || move.b) v.z -= dir.z * speed * dt;
    if (move.l || move.r) v.x -= dir.x * speed * dt;
    controls.moveRight(-v.x * dt);
    controls.moveForward(-v.z * dt);
    camera.position.x = Math.max(-22, Math.min(22, camera.position.x));
    camera.position.z = Math.max(-22, Math.min(22, camera.position.z));
    camera.position.y = 1.7;
  }
  renderer.render(scene, camera);
}
animate();

window.addEventListener('resize', ()=>{
  camera.aspect = stage.clientWidth/stage.clientHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(stage.clientWidth, stage.clientHeight);
});
`;
  // Inject as a module script
  const moduleScript = document.createElement('script');
  moduleScript.type = 'module';
  moduleScript.textContent = code;
  document.body.appendChild(moduleScript);
})();